import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, FormFeedback } from "reactstrap";
import { setStorage } from "../../helper/storage";
import { InputField } from "../../Component/Common/InputField";
import AuthLayout from "./AuthLayout";
import { loginSchema } from "../../helper/errorSchema";
import { userLogin } from "../../services";
import "react-toastify/dist/ReactToastify.css";
import { checkFormError } from "../../helper";
import { toast } from "react-toastify";

export function Login() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState({
    username: "",
    password: "",
  });
  const [showPassword1, setShowPassword1] = useState(false);
  const [inputError, setInputError] = useState(false);


  const togglePasswordVisibility1 = () => {
    setShowPassword1((prev) => !prev);
  };

  const submit = async () => {
    const validationResult = await checkFormError(inputValue, loginSchema);
    if (validationResult === true) {
      setIsLoading(true);
      const res = await userLogin(inputValue);
      if (res?.success === true) {
        setStorage("logged-in", res?.results);
        navigate("/dashboard");
      } else {
        setInputError((s) => ({
          ...s,
          response: res?.error?.detail,
        }));
        toast.error(res?.error?.detail);
      }
      setIsLoading(false);
    } else {
      setInputError(validationResult);
      setIsLoading(false);
    }
  };

  const handleOnChange = async (name, value) => {
    const stateObj = { ...inputValue, [name]: value };
    setInputValue(stateObj);
    if (!!inputError) {
      const error = await checkFormError(stateObj, loginSchema);
      setInputError(error);
    }
  };

  const onkeyPress = (e) => {
    if (e.keyCode === 13) {
      submit();
    }
  };

  return (
    <div className="login_div">
      <AuthLayout>
        <Form className="login_form">
          <InputField
            className="modal_input orderModal_Input"
            labelClass="FormLableKaran"
            placeholder="Enter Username"
            label="Username"
            labelSpan="*"
            labelSpanClass="style_for_star"
            name="username"
            type="text"
            onChange={({ target: { name, value } }) =>
              handleOnChange(name, value)
            }
            focus={!!inputError.username}
            error={inputError.username}
            value={inputValue.username}
            onKeyDown={(e) => onkeyPress(e)}
          />
          <InputField
            className="modal_input orderModal_Input"
            labelClass="FormLableKaran"
            label="Password"
            placeholder="Enter Password"
            name="password"
            type="password"
            labelSpan="*"
            labelSpanClass="style_for_star"
            showPassword={showPassword1}
            showHandle={togglePasswordVisibility1}
            focus={!!inputError?.password}
            error={inputError.password}
            value={inputValue?.password}
            onChange={({ target: { name, value } }) =>
              handleOnChange(name, value)
            }
            onKeyDown={(e) => onkeyPress(e)}
          />

          {inputError.response && (
            <FormFeedback>{inputError.response}</FormFeedback>
          )}
          <div className="login_submit_row">
            <Button type="button" className="login_form_btn" onClick={() => submit()} disabled={isLoading}>
              {isLoading ? "Signing in…" : "Login"}
            </Button>
          </div>
        </Form>
      </AuthLayout>
    </div>
  );
}
